import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageData } from 'src/app/Entities';

@Component({
  selector: 'app-titulo-header',
  templateUrl: './titulo-header.component.html',
  styleUrls: ['./titulo-header.component.css']
})
export class TituloHeaderComponent {
  @Input() titulo: string = '';
  @Input() subtitulo: string = '';

  pageData: PageData = {
    title: '',
    pageDescription: '',
  };

  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.data.subscribe(data => {
      this.pageData = { ...data };
      document.title = this.pageData && this.pageData.title ? this.pageData.title?.toString() : "";
    });
  }
  ngOnChanges(): void {
    if (!this.pageData.title) {
      this.pageData.title = this.titulo;
    }
    if (!this.pageData.pageDescription) {
      this.pageData.pageDescription = this.subtitulo;
    }
  }
}
